export const keyMap: { [key: string]: string } = {
  commercial: require('./commercial.jpg'),
  flatRent: require('./flat_rent.jpg'),
  flatSale: require('./flat_sale.jpg'),
  daily: require('./rent_daily.jpg'),
  newobject: require('./residential_complexes.jpg'),
  suburban: require('./suburban.jpg'),
};
